import React, { Component, Context, CSSProperties } from "react";
import { IPlatformContext, PlatformContext } from "../../laco-common/platform/context";

export type HyperLinkProps = {
	title: string;
	url: string;
	notTargetBlank?: boolean;
	ignoreLinkCheck?: boolean;
	style?: CSSProperties;
	children?: React.ReactNode;
};

export default class HyperLink extends Component<HyperLinkProps> {
	static contextType: Context<IPlatformContext> = PlatformContext;

	render() {
		const renderer: typeof renderMobileHyperLink = this.context.renderHyperLink || renderMobileHyperLink;
		return renderer({
			...this.props,
			style: this.props.style,
		});
	}
}

export const renderMobileHyperLink = (props: HyperLinkProps) =>
	props.children ? (
		<span onClick={() => openURL(props.url, props.ignoreLinkCheck)}>{props.children}</span>
	) : (
		<span style={props.style} onClick={() => openURL(props.url, props.ignoreLinkCheck)}>
			{props.title || props.url}
		</span>
	);

function openURL(url: string, ignoreLinkCheck?: boolean) {
	window.open(url);
}
